import { InternalOrderDetailPrintModel } from "./internal-order-detail-print.model";

export class InternalOrderPrintModel {
  internalOrderId: number | null = null
  companyId: number | null = null
  branchId: number | null = null
  branchCode: string | null = null
  branchName: string | null = null;
  enterpriseId: number | null = null
  enterpriseNit: string | null = null;
  enterpriseName: string | null = null;
  consecutive: string | null = null
  alterNumber: string | null = null;
  dateInternalOrder: Date | null = null;
  internalOrderStateId: number | null = null
  internalOrderState: string | null = null;
  responsible: string | null = null;
  observation: string | null = null;
  internalOrderDetails: InternalOrderDetailPrintModel[] | null = null;

}